import { useState, useEffect } from 'react';
import Navigation from './Navigation';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTasting = () => {
    const tastingSection = document.getElementById('degustacao');
    if (tastingSection) {
      tastingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-[60vh] sm:h-screen min-h-[400px] sm:min-h-[600px] w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4e61bdef1f25f364185b848667f6abf6.jpg"
          alt="Cocktail Premium Barem"
          className="w-full h-full object-cover object-center"
          style={{ objectPosition: 'center center' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70 sm:bg-gradient-to-r sm:from-black/70 sm:via-black/40 sm:to-transparent"></div>
      </div>

      {/* Navigation */}
      <Navigation scrolled={scrolled} />

      {/* Hero Content */}
      <div className="relative h-full flex items-center justify-center sm:justify-start">
        <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 w-full">
          <div className="max-w-2xl text-center sm:text-left">
            <h1 className="font-serif text-2xl sm:text-5xl lg:text-7xl font-light text-white mb-3 sm:mb-8 leading-tight tracking-wide">
              Coquetelaria que<br />Eleva Experiências
            </h1>
            <p className="text-xs sm:text-lg font-light text-gray-300 mb-6 sm:mb-12 leading-relaxed max-w-xl mx-auto sm:mx-0">
              Técnica clássica e coquetelaria contemporânea para eventos sociais e corporativos de alto padrão
            </p>
            <div className="flex justify-center sm:justify-start">
              <button
                onClick={scrollToTasting}
                className="w-full sm:w-auto group relative px-8 sm:px-12 py-3 sm:py-5 border border-[#D4AF37] text-white text-xs sm:text-sm uppercase tracking-widest font-light overflow-hidden transition-all duration-500 hover:text-black whitespace-nowrap cursor-pointer"
              >
                <span className="absolute inset-0 bg-[#D4AF37] transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></span>
                <span className="relative">Agende sua Degustação</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 sm:bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#D4AF37] rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-[#D4AF37] rounded-full"></div>
        </div>
      </div>
    </section>
  );
}